import CarouselViewAllLink from 'components/Common/CarouselViewAllLink'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import type { ReactNode } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'

interface Props {
  allTo?: string
  allHref?: string
  children: ReactNode
  variant?: React.ComponentProps<typeof Heading>['variant']
}

function OfferCarouselHeader(props: Props) {
  const { allTo, allHref, children, variant = 'heading2' } = props
  const intl = useIntl()

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="start" gap={16}>
      <Heading variant={variant}>
        {children}
      </Heading>
      {!!(allTo || allHref) && <Group direction="horizontal" gap={16} verticalAlign="center">
        <CarouselViewAllLink to={allTo} href={allHref}>
          {intl.formatMessage({
            id: 'p0dE7G3AQEjKShJ_YDSr',
            defaultMessage: 'View all',
          })}
        </CarouselViewAllLink>
      </Group>}
    </Group>
  )
}

export default OfferCarouselHeader
